import {ChecklistShape} from '../../services/ChecklistService';

export const RECEIVE_CHECKLIST = 'CHECKLIST/RECEIVE_CHECKLIST';

export const receiveChecklist = (checklist: ChecklistShape) => ({
  type: RECEIVE_CHECKLIST,
  payload: checklist,
});
